<template>
  <div class="order-item">
    <div class="header">
      <span class="title"> {{ headerTitle }}  <i> {{ item.number }} </i> </span>
      <span :class="['status', item.state]"> {{ headerStatus }} </span>
    </div>
    <div class="contain">
      <div class="info">
        <component :is="componentName" :item="item" />
      </div>
      <div class="worth">
        <template v-if="item.creditsUsed !== null">
          <span class="credits">
            {{ item.creditsUsed }}
          </span>
          积分
        </template>
        <template v-else>
          ¥ <span v-money="item.cashUsed" class="cash" />
        </template>
      </div>
    </div>
    <div v-if="item.state === 'paying'" class="button-wrapper">
      <van-button
        class="pay-button"
        loading-text="加载中..."
        :loading="payLoading"
        @click="payHandler"
      >去支付</van-button>
    </div>
  </div>
</template>

<script>
import Vip from './VipContain'
import Video from './VideoContain'
import Creation from './CreationContain'
import Character from './CharacterContain'
import Commodity from './CommodityContain'
import Applet from './AppletContain'

export default {
  name: 'OrderItem',
  components: { Vip, Video, Creation, Character, Commodity, Applet },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    payLoading: false
  }),
  computed: {
    productInfo () {
      return this.item.target
    },
    headerTitle () {
      let headerTitle
      switch (this.item.targetType) {
        case 'Character':
          headerTitle = '在线学习-单字解锁'
          break
        case 'Video':
          headerTitle = '在线学习-知讯解锁'
          break
        case 'Creation':
          headerTitle = '在线学习-集字创作'
          break
        case 'Vip':
          headerTitle = '会员'
          break
        case 'Applet':
          headerTitle = '工具'
          break
        case 'Commodity':
          headerTitle = '商品购买'
          break
      }
      return headerTitle
    },
    headerStatus () {
      let headerStatus
      switch (this.item.state) {
        case 'paying':
          headerStatus = '未支付'
          break
        case 'payed':
          headerStatus = '已支付，等待收货'
          break
        case 'completed':
          headerStatus = '已完成'
          break
        case 'canceled':
          headerStatus = '已取消'
          break
      }
      return headerStatus
    },
    componentName () {
      return this.item.targetType
    }
  },
  methods: {
    payHandler () {
      this.payLoading = true
      this.$emit('pay', () => {
        this.payLoading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.order-item {
  @include wh(100%, inherit);
  border-radius:8px;
  background-color: #fff;
  overflow: hidden;
  .header {
    @include clear;
    @include sc($font-size-base, $color-text-heavy);
    padding: 12px 16px;
    border-bottom: 1px solid #E0E0E0;
    .title {
      float: left;
    }
    .status {
      @include lw(17px, 500);
      float: right;
      &.paying {
        color: #FF3333;
      }
      &.payed {
        color: #00C038;
      }
      &.completed {
        color: $color-text-heavy;
      }
      &.canceled {
        color: $color-text-heavy;
      }
    }
  }
  .contain {
    @include ftb;
    padding: 12px 16px;
    .info {
      flex-basis: 228px;
    }
    .worth {
      @include sc($font-size-base, #FF3333);
      flex-grow: 1;
      text-align: right;
      .credits {
        @include sc($font-size-xl, inherit);
        @include lw(24px, 500);
      }
      .cash {
        @include sc($font-size-xl, inherit);
        @include lw(24px, 500);
        ::v-deep .point {
          @include sc($font-size-base, inherit);
          @include lw(24px, 400);
        }
      }
    }
  }
  .button-wrapper {
    @include clear;
    padding: 12px 16px;
    border-top: 1px solid #e0e0e0;
    .pay-button {
      @include normal-button(inherit, 29px);
      @include lg-radius(#ECCEA2, #E7B170);
      float: right;
      padding: 0 10px;
    }
  }
}
</style>
